export const Characters = {
  U: 'ABCDEFGHIJKLMNOIPQRSTUVXYZ',
  L: 'abcdefghijklmnopqrstuvwxyz',
  D: '0123456789',
  B: '(){}[]<>',
  P: "!\"'.,?;:",
  S: '-_\\/£$%^&*=+@#~'
}



// WEBPACK FOOTER //
// ./src/data/Characters.js